import { render, staticRenderFns } from "./RapipagoArchivoPage.vue?vue&type=template&id=4cd6d2ca&scoped=true"
import script from "./RapipagoArchivoPage.vue?vue&type=script&lang=js"
export * from "./RapipagoArchivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6d2ca",
  null
  
)

export default component.exports